"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const deleteFromDatabaseFunction = ({ database, }) => ({ path, listener, shouldUpdateDbCache, projectId, setRenderDbCache, isDevelopment, }) => {
    const dbName = isDevelopment ? 'dataDevelopment' : 'data';
    database.ref(`projects/${projectId}/${dbName}/${path}`).remove()
        .then(() => {
        if (shouldUpdateDbCache) {
            setRenderDbCache({
                data: undefined,
                route: { path },
            });
        }
        listener(true);
    })
        .catch(() => {
        listener(false);
    });
};
exports.default = deleteFromDatabaseFunction;
